import React, { useEffect, useState } from "react";
import { api } from "./api";

const b64ToU8 = (s) => {
  const pad = "=".repeat((4 - (s.length % 4)) % 4);
  const raw = atob((s + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((ch) => ch.charCodeAt(0)));
};

const supported =
  typeof window !== "undefined" &&
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export default function PushToggle({ notify }) {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  // Si ya estaba activado, vuelve a registrar la suscripción con la cuenta actual
  useEffect(() => {
    if (!supported) return;
    (async () => {
      try {
        const reg = await navigator.serviceWorker.register("/sw.js");
        await navigator.serviceWorker.ready;
        const sub = await reg.pushManager.getSubscription();
        if (sub && Notification.permission === "granted") {
          await api("/api/push/subscribe", { method: "POST", body: sub.toJSON() });
          setOn(true);
        }
      } catch {}
    })();
  }, []);

  const enable = async () => {
    setBusy(true);
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") throw new Error("Permiso denegado. Actívalo en los ajustes del navegador.");
      const reg = await navigator.serviceWorker.register("/sw.js");
      await navigator.serviceWorker.ready;
      const { key } = await api("/api/push/key");
      if (!key) throw new Error("El servidor no tiene las notificaciones configuradas");
      const sub = (await reg.pushManager.getSubscription()) ||
        (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(key) }));
      await api("/api/push/subscribe", { method: "POST", body: sub.toJSON() });
      setOn(true);
      notify("Notificaciones activadas");
    } catch (e) { notify(e.message, true); }
    setBusy(false);
  };

  const disable = async () => {
    setBusy(true);
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      if (sub) {
        await api("/api/push/unsubscribe", { method: "POST", body: { endpoint: sub.endpoint } });
        await sub.unsubscribe();
      }
      setOn(false);
      notify("Notificaciones desactivadas");
    } catch (e) { notify(e.message, true); }
    setBusy(false);
  };

  if (!supported) {
    return (
      <div className="alert alert-info">
        Para recibir avisos en iPhone: abre el menú Compartir de Safari, elige "Agregar a pantalla de inicio" y abre Cozobi desde ese ícono.
      </div>
    );
  }

  return on ? (
    <button className="btn btn-sm btn-soft" disabled={busy} onClick={disable}>🔔 Avisos de pedidos activados · Desactivar</button>
  ) : (
    <button className="btn btn-block" disabled={busy} onClick={enable}>🔔 Activar avisos de pedidos nuevos</button>
  );
}